__turbopack_context__.v({
  "container": "FormatButton-module__vi9zSq__container",
  "containerDisabled": "FormatButton-module__vi9zSq__containerDisabled",
  "containerSelected": "FormatButton-module__vi9zSq__containerSelected",
  "image": "FormatButton-module__vi9zSq__image",
  "price": "FormatButton-module__vi9zSq__price",
  "size": "FormatButton-module__vi9zSq__size",
  "tooltip": "FormatButton-module__vi9zSq__tooltip",
});
